// extracted by mini-css-extract-plugin
export var attachmentContainer = "_nb-0";
export var fileList = "_nb-2";
export var removeFileButton = "_nb-1";